import axios from 'axios';
import qs from 'qs';
// import hexMD5 from '@/utils/md5.js';
// import Base64 from '@/utils/base64js.min.js';
import CryptoJS from 'crypto-js';
import { CONFIG } from '@/config';

const appkey = 'bQ1b48g1WD6P9W375DyVGtGv5EXyYtnE';
const appid = 'lg314nprc1jy8b02';

const isLocal = false;

axios.defaults.baseURL = CONFIG.apihost;

// axios.defaults.baseURL = isLocal
//     ? // ? 'http://192.168.1.82:3000/'
//       'http://192.168.1.205:3000/'
//     : 'https://fiveyearh5.uz3.net/';

// 请求头签名
const _signnature = e => {
    const { url, data, token, lang } = e;
    let _parameter = '';
    if (data) {
        _parameter = Object.values(data)
            .sort()
            .join('');
    }
    const timestamp = new Date().getTime();
    const _p = `${url}${timestamp}${_parameter}${appkey}`;
    // console.log(_p);
    // const _md5 = hexMD5(_p);
    // const _workArray = encodeURIComponent(_md5);
    // const _base64 = Base64.encode(_workArray);
    const _md5 = CryptoJS.MD5(_p).toString();
    const _workArray = CryptoJS.enc.Utf8.parse(_md5);
    const _base64 = CryptoJS.enc.Base64.stringify(_workArray);
    let header_data = {
        appid,
        timestamp,
        signature: _base64,
        token,
        lang,
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    return header_data;
};

// 基本请求
export const baseRequest = async request_obj => {
    const headers = _signnature(request_obj);
    const result = await axios({
        method: 'post',
        url: request_obj.url,
        headers,
        data: qs.stringify(request_obj.data)
    });
    if (result.status !== 200) {
        alert('network error');
    } else {
        return result.data;
    }
};
